import { NgModule } from '@angular/core';

import { LegalRoutingModule } from './legal-routing.module';
import { LegalComponent } from './legal.component';
import { CustomLayoutModule } from '../../custom-layout/custom-layout.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [LegalComponent],
  imports: [
    CommonModule,
    LegalRoutingModule,
    CustomLayoutModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    MatDialogModule
  ],
  providers: [
    CustomizationService,
  ],
})
export class LegalModule { }
